import React from "react";
import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import { type NotificationTemplateResource } from "@exonn/js-sdk";

export const module: ModuleOptions<NotificationTemplateResource> = {
  resource: ResourceEnum.NotificationTemplate,
  bigIcon: <span className={"icon-20-msg_tmpl"} />,
  smallIcon: <span className={"icon-15-msg_tmpl"} />,
};
